import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { EnvironmentService } from '@app/core/services/environment.service';
import { Observable } from 'rxjs';
import { CreateExchangeRate, Currency, CurrencyEnableDisable, CurrencyVerbose, ExchangeRate, UpdateExchangeRate } from '../models/currencies.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root'
})
export class CurrenciesService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  getCurrencies(filterString?: string, sort?: string, asOf?: string): Observable<Currency[]> {
    let params = new HttpParams();
    filterString ? params = params.append('Filter', filterString) : null;
    sort ? params = params.append('sort', sort) : null;
    asOf ? params = params.append('AsOf', asOf) : null;

    return this.http
      .get<any>(`${this.envService.env.apiUrl}${api_routes.CURRENCIES}`, {
        headers: headers,
        params: params
      })
  }

  getCurrency(id: string): Observable<CurrencyVerbose> {
    return this.http
      .get<CurrencyVerbose>(`${this.envService.env.apiUrl}${api_routes.CURRENCIES}/${id}`, {
        headers: headers
      });
  }

  enableDisableCurrency(id: string, data: CurrencyEnableDisable): Observable<any> {
    return this.http
      .put<any>(`${this.envService.env.apiUrl}${api_routes.CURRENCIES}/${id}`, data, {
        headers: headers
      });
  }

  /*
 
   _____          _                              ____       _            
  | ____|_  _____| |__   __ _ _ __   __ _  ___  |  _ \ __ _| |_ ___  ___ 
  |  _| \ \/ / __| '_ \ / _` | '_ \ / _` |/ _ \ | |_) / _` | __/ _ \/ __|
  | |___ >  < (__| | | | (_| | | | | (_| |  __/ |  _ < (_| | ||  __/\__ \
  |_____/_/\_\___|_| |_|\__,_|_| |_|\__, |\___| |_| \_\__,_|\__\___||___/
                                    |___/                                
 
*/

  getExchangeRates(currencyId: string, take?: number, skip?: number, filterString?: string, sort?: string): Observable<PagedData<ExchangeRate>> {
    let params = new HttpParams();
    take ? params = params.append('take', take) : null;
    skip ? params = params.append('skip', skip) : null;
    filterString ? params = params.append('Filter', filterString) : null;
    sort ? params = params.append('sort', sort) : null;

    return this.http
      .get<PagedData<ExchangeRate>>(`${this.envService.env.apiUrl}${api_routes.ADMIN}/${api_routes.CURRENCIES}/${currencyId}/${api_routes.EXCHANGE_RATES}`, {
        headers: headers,
        params: params
      });
  }

  getExchangeRate(id: string): Observable<ExchangeRate> {
    return this.http
      .get<ExchangeRate>(`${this.envService.env.apiUrl}${api_routes.ADMIN}/${api_routes.EXCHANGE_RATES}/${id}`, {
        headers: headers
      });
  }

  createExchangeRate(data: CreateExchangeRate): Observable<any> {
    return this.http
      .post<any>(`${this.envService.env.apiUrl}${api_routes.ADMIN}/${api_routes.EXCHANGE_RATES}`, data, {
        headers: headers
      });
  }

  updateExchangeRate(id: string, data: UpdateExchangeRate): Observable<any> {
    return this.http
      .put<any>(`${this.envService.env.apiUrl}${api_routes.ADMIN}/${api_routes.EXCHANGE_RATES}/${id}`, data, {
        headers: headers
      });
  }

  deleteExchangeRate(id: string): Observable<any> {
    return this.http
      .delete<any>(`${this.envService.env.apiUrl}${api_routes.ADMIN}/${api_routes.EXCHANGE_RATES}/${id}`, {
        headers: headers
      });
  } 
}
